import { Pipe, PipeTransform } from '@angular/core';

@Pipe({
  name: 'ancillariesByRoute'
})
export class AncillariesByRoutePipe implements PipeTransform {

transform(ancillaries: any): { route: string, items: any[] }[] {
    if (!ancillaries || typeof ancillaries !== 'object') return [];
    return Object.entries(ancillaries).map(([route, items]) => ({
      route,
      items: Array.isArray(items) ? items : []
    }));
  }

}
